import React from 'react';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import { CarDetailsPlayback } from '../car_details_playback/car_details_playback';
import { CarSeriesDescription } from '../car_series_description/car_series_description';
import { ClickToEditCarDetails } from '../click_to_edit_car_details/click_to_edit_car_details';
import styles from './car_summary_details.css';

/**
 * Render the Car Summary Details component
 * @param {Object} props - the incoming set of props
 * @returns {Node} A component
 */

const useStyles = createUseStyles(() => ({
    carDetailsPlayback: {
        /**
         * CarDetailsPlayback component has a default marginBottom: '-1.5rem'
         * The design has a marginBottom: '2.4rem'
         * So we need to add 1.5rem to the marginBottom to cancel it out
         */
        marginBottom: '3.9rem'
    },
    carSeriesDescription: {
        marginBottom: '3.2rem'
    }
}));
const _CarSummaryDetails = () => {
    const classes = useStyles();
    return (
        <div className={styles.root}>
            <CarDetailsPlayback className={classes.carDetailsPlayback} />
            <CarSeriesDescription className={classes.carSeriesDescription} />
            <ClickToEditCarDetails />
        </div>
    );
};

/**
 * Map state to our component props
 * @param {Object} state - the application state
 * @returns {Object} - the set of mapped props for the component
 */
const mapStateToProps = () => {
    return {};
};

const CarSummaryDetails = connect(mapStateToProps)(_CarSummaryDetails);

export { CarSummaryDetails, _CarSummaryDetails };
